module.exports = __webpack_public_path__ + "static/media/dominik.6fcc9efd.jpg";